import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=06c323af&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=ts"
export * from "./AlertPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AlertPanel.vue?vue&type=style&index=0&id=06c323af&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "06c323af",
  null
  ,true
)

export default component.exports